import { sharedCareScoutQuestions } from './careScoutAppSharedQuestions';
import { sharedCareScoutSections } from './careScoutAppSharedSections';

const questions: Record<string, PolicyFormQuestion> = {
  ...sharedCareScoutQuestions,
  deductiblePeriod: {
    id: 'deductible-period',
    questionRef: 'deductiblePeriod',
    title: 'Deductible Period',
    type: 'radio',
    required: true,
    options: [{ id: '90-days', value: '90 Days' }],
  },
  dailyBenefitAmount: {
    id: 'daily-benefit-amount',
    questionRef: 'dailyBenefitAmount',
    title: 'Daily Benefit Amount',
    type: 'radio',
    required: true,
    options: [
      { id: '100', value: '$100' },
      { id: '150', value: '$150' },
      { id: '200', value: '$200' },
    ],
  },
};

export const careScoutVTFormDefinition: PolicyFormDefinition = {
  sections: [
    sharedCareScoutSections.coverageSelection,
    sharedCareScoutSections.eftPaymentAuth,
    sharedCareScoutSections.applicantProfile,
    sharedCareScoutSections.insurabilityProfile,
    sharedCareScoutSections.medicalQuestions,
    sharedCareScoutSections.socialHistory,
    sharedCareScoutSections.familyHistory,
    sharedCareScoutSections.otherCoverage,
    sharedCareScoutSections.protectionLapse,
    sharedCareScoutSections.producerSignature,
    sharedCareScoutSections.ltcAppOverflowForm,
    sharedCareScoutSections.healthInsuranceAuthorization,
    sharedCareScoutSections.ltcInsurancePersonalWorksheet,
    sharedCareScoutSections.verificationFinancialNonDisclosure,
    sharedCareScoutSections.ltcPotentialRateIncreaseDisclosure,
    sharedCareScoutSections.licensedInsuranceProducerInformation,
  ],
  questions,
};
